import React from 'react';
import styled from 'styled-components';
import { Icon } from './_base';

const GooglePlayBadgeSVG = styled(Icon).attrs({ viewBox: '0 0 135 40' })`
    width: 3.375em;
`;

function GooglePlayBadge(props) {
    return (
        <GooglePlayBadgeSVG
            data-test="icon-google-play"
            {...props}
            xmlns="http://www.w3.org/2000/svg"
        >
            <defs>
                <linearGradient
                    gradientTransform="matrix(1 0 0 -1 0 182)"
                    gradientUnits="userSpaceOnUse"
                    id="a"
                    x1="21.8"
                    x2="5.02"
                    y1="173.29"
                    y2="156.51"
                >
                    <stop offset="0" stopColor="#00a0ff" />
                    <stop offset=".01" stopColor="#00a1ff" />
                    <stop offset=".26" stopColor="#00beff" />
                    <stop offset=".51" stopColor="#00d2ff" />
                    <stop offset=".76" stopColor="#00dfff" />
                    <stop offset="1" stopColor="#00e3ff" />
                </linearGradient>
                <linearGradient
                    gradientTransform="matrix(1 0 0 -1 0 182)"
                    gradientUnits="userSpaceOnUse"
                    id="b"
                    x1="33.83"
                    x2="9.64"
                    y1="162"
                    y2="162"
                >
                    <stop offset="0" stopColor="#ffe000" />
                    <stop offset=".41" stopColor="#ffbd00" />
                    <stop offset=".78" stopColor="orange" />
                    <stop offset="1" stopColor="#ff9c00" />
                </linearGradient>
                <linearGradient
                    gradientTransform="matrix(1 0 0 -1 0 182)"
                    gradientUnits="userSpaceOnUse"
                    id="c"
                    x1="24.83"
                    x2="2.07"
                    y1="159.7"
                    y2="136.95"
                >
                    <stop offset="0" stopColor="#ff3a44" />
                    <stop offset="1" stopColor="#c31162" />
                </linearGradient>
                <linearGradient
                    gradientTransform="matrix(1 0 0 -1 0 182)"
                    gradientUnits="userSpaceOnUse"
                    id="d"
                    x1="7.3"
                    x2="17.46"
                    y1="181.82"
                    y2="171.66"
                >
                    <stop offset="0" stopColor="#32a071" />
                    <stop offset=".07" stopColor="#2da771" />
                    <stop offset=".48" stopColor="#15cf74" />
                    <stop offset=".8" stopColor="#06e775" />
                    <stop offset="1" stopColor="#00f076" />
                </linearGradient>
            </defs>

            <rect height="40" rx="5" ry="5" width="135" />
            <path
                d="M47.42 10.24a2.7 2.7 0 0 1-.75 2 2.9 2.9 0 0 1-2.2.9A3.1 3.1 0 0 1 41.35 10a3.1 3.1 0 0 1 3.12-3.13 3.1 3.1 0 0 1 1.23.25 2.48 2.48 0 0 1 .94.67l-.53.52a2.03 2.03 0 0 0-1.63-.72 2.32 2.32 0 0 0-2.33 2.4 2.36 2.36 0 0 0 4 1.73 1.9 1.9 0 0 0 .5-1.22h-2.17v-.7h2.9a2.54 2.54 0 0 1 .05.44zM52.03 7.74H49.3v1.9h2.46v.72H49.3v1.9h2.73V13h-3.5V7h3.5zM55.28 13h-.77V7.74h-1.67V7h4.12v.74h-1.67zM59.94 13V7h.77v6zM64.13 13h-.77V7.74h-1.68V7h4.12v.74h-1.67zM73.6 12.22a3.12 3.12 0 0 1-4.4 0 3.07 3.07 0 0 1-.87-2.22 3.07 3.07 0 0 1 .88-2.22 3.1 3.1 0 0 1 4.4 0 3.07 3.07 0 0 1 .9 2.22 3.07 3.07 0 0 1-.9 2.22zm-3.82-.5a2.3 2.3 0 0 0 3.26 0A2.35 2.35 0 0 0 73.7 10a2.35 2.35 0 0 0-.66-1.72 2.3 2.3 0 0 0-3.26 0A2.35 2.35 0 0 0 69.1 10a2.35 2.35 0 0 0 .68 1.72zM75.58 13V7h.93l2.93 4.67h.03l-.03-1.16V7h.77v6h-.8l-3.05-4.9h-.04l.05 1.16V13z"
                fill="#fff"
                stroke="#fff"
                strokeMiterlimit="10"
                strokeWidth=".2"
            />
            <path
                d="M68.14 21.75A4.25 4.25 0 1 0 72.4 26a4.2 4.2 0 0 0-4.26-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-9.32-6.83A4.25 4.25 0 1 0 63.1 26a4.2 4.2 0 0 0-4.28-4.25zm0 6.83a2.58 2.58 0 1 1 2.4-2.58 2.46 2.46 0 0 1-2.4 2.58zm-11.08-5.52v1.8h4.32a3.77 3.77 0 0 1-.98 2.27 4.42 4.42 0 0 1-3.34 1.32 4.8 4.8 0 0 1 0-9.6 4.6 4.6 0 0 1 3.26 1.3l1.27-1.28a6.3 6.3 0 0 0-4.53-1.82 6.6 6.6 0 1 0 0 13.2 6.04 6.04 0 0 0 4.6-1.84 5.96 5.96 0 0 0 1.57-4.22 5.87 5.87 0 0 0-.08-1.12zm45.3 1.4a3.95 3.95 0 0 0-3.63-2.7 4.04 4.04 0 0 0-4 4.24 4.16 4.16 0 0 0 4.22 4.26 4.23 4.23 0 0 0 3.54-1.9l-1.45-.95a2.43 2.43 0 0 1-2.08 1.18 2.16 2.16 0 0 1-2.06-1.3l5.68-2.34zm-5.8 1.42a2.33 2.33 0 0 1 2.24-2.5 1.65 1.65 0 0 1 1.57.92zM82.65 30h1.86V17.5h-1.87zm-3.07-7.3h-.07a2.95 2.95 0 0 0-2.24-.95 4.26 4.26 0 0 0 0 8.5 2.9 2.9 0 0 0 2.24-.96h.07v.6c0 1.63-.87 2.5-2.27 2.5a2.35 2.35 0 0 1-2.15-1.5l-1.62.66a4.05 4.05 0 0 0 3.77 2.52c2.2 0 4.04-1.3 4.04-4.43V22h-1.77zm-2.15 5.88a2.6 2.6 0 0 1 0-5.15 2.4 2.4 0 0 1 2.28 2.6 2.38 2.38 0 0 1-2.28 2.55zm24.4-11.08h-4.5V30h1.88v-4.74h2.6a3.9 3.9 0 1 0 0-7.76zm.03 6.02H99.2v-4.28h2.65a2.14 2.14 0 1 1 0 4.28zm11.54-1.8a3.5 3.5 0 0 0-3.34 1.92l1.65.7a1.77 1.77 0 0 1 1.72-.92 1.8 1.8 0 0 1 1.96 1.6v.13a4.13 4.13 0 0 0-1.95-.48c-1.78 0-3.6.98-3.6 2.82a2.9 2.9 0 0 0 3.1 2.74 2.63 2.63 0 0 0 2.4-1.23h.05V30h1.8v-4.8c0-2.2-1.66-3.45-3.8-3.45zm-.24 6.86c-.6 0-1.46-.3-1.46-1.06 0-.97 1.06-1.34 1.97-1.34a3.32 3.32 0 0 1 1.7.42 2.26 2.26 0 0 1-2.2 1.98zM123.74 22l-2.14 5.42h-.06L119.32 22h-2l3.32 7.58-1.9 4.2h1.95L125.8 22zm-16.8 8h1.86V17.5h-1.86z"
                fill="#fff"
            />
            <path
                d="M10.44 7.54a2 2 0 0 0-.47 1.4v22.12a2 2 0 0 0 .47 1.4l.07.08 12.4-12.4v-.3L10.5 7.48z"
                fill="url(#a)"
            />
            <path
                d="M27.03 24.28l-4.13-4.13v-.3l4.13-4.13.1.06L32 18.56c1.4.8 1.4 2.1 0 2.9l-4.88 2.77z"
                fill="url(#b)"
            />
            <path
                d="M27.12 24.23L22.9 20 10.44 32.46a1.63 1.63 0 0 0 2.07.07l14.62-8.3"
                fill="url(#c)"
            />
            <path
                d="M27.12 15.78l-14.6-8.3a1.63 1.63 0 0 0-2.08.06L22.9 20z"
                fill="url(#d)"
            />
            <path
                d="M27.03 24.13L12.5 32.38a1.67 1.67 0 0 1-2 0l-.06.08.07.08a1.66 1.66 0 0 0 2 0l14.62-8.3z"
                opacity=".2"
                style={{ isolation: 'isolate' }}
            />
            <path
                d="M10.44 32.32a2 2 0 0 1-.47-1.4v.14a2 2 0 0 0 .47 1.4l.07-.07zM32 21.3l-4.97 2.83.1.1L32 21.45A1.75 1.75 0 0 0 33.07 20 1.86 1.86 0 0 1 32 21.3z"
                opacity=".12"
                style={{ isolation: 'isolate' }}
            />
            <path
                d="M12.5 7.62L32 18.7a1.86 1.86 0 0 1 1.06 1.3A1.75 1.75 0 0 0 32 18.56L12.5 7.48c-1.38-.8-2.53-.14-2.53 1.46v.15c0-1.6 1.15-2.27 2.54-1.48z"
                fill="#fff"
                opacity=".25"
                style={{ isolation: 'isolate' }}
            />
        </GooglePlayBadgeSVG>
    );
}

export { GooglePlayBadge as default, GooglePlayBadge };
